// Single source of truth for the numbers shown at the point of commitment
// (chat intake, signup fine print). Must agree with the sales agent's
// server-side `PRICING` (apps/api/src/modules/sales/conversation.ts) and
// with `ENTRY_TIER_CREDITS` / the plan catalog Checkout actually charges.

export const TRIAL_DAYS = 14;

/** Entry-tier monthly price. Mirrors `PRO_TIERS[0]` in the API's plan catalog. */
export const MONTHLY_PRICE_USD = 25;

/** Entry-tier annual price. Mirrors `PRO_TIERS[0].annualPriceCents`. */
export const ANNUAL_PRICE_USD = 250;

/** Human date the trial ends (and the first charge lands) if it started `from`. */
export function trialEndDate(from: Date = new Date()): string {
  const end = new Date(from);
  end.setDate(end.getDate() + TRIAL_DAYS);
  return end.toLocaleDateString("en-US", { month: "long", day: "numeric" });
}
